<template>
  <div>
    -----------자녀[{{componentId}}]---------
    <button @click="onRemoveComponent">삭제</button><br>
    자녀 이름 : <input v-model="child.name" placeholder="이름" />
    <br />남성(
    <input type="radio" value="M" v-model="child.sex" />)
    여성(
    <input type="radio" value="F" v-model="child.sex" />)
  </div>
</template>

<script>
export default {
  data() {
    return {
      componentId: '',
      child: {
        name: '',
        sex: 'M'
      }
    };
  },
  methods: {
    onRemoveComponent() {
      console.log('Dynamic-component.vue <onRemoveComponent.componentId>', this.componentId);
      this.$parent.$emit('onRemoveComponent', this.componentId);
    }
  },
  created: function() {
    console.log(this.$vnode);
    this.componentId = this.$vnode.key;
    console.log('Dynamic-component.vue <created.componentId>', this.componentId);
  },
  beforeUpdate: function() {
  }
}
</script>